<template>
    <div class="actions-filter" v-if="currentCity.length && actionsItems != null">
        <div class="actions-filter-city">
            <ul>
                <li>
                    <a href="#" @click.prevent="allActions" :class="{active : allActionsInit}">Все акции</a>
                </li>
                <li v-for="(item, index) in cityFilter" :key="index">
                    <a href="#" @click.prevent="filterByCity(item)" :class="{active : cityActive === item}">{{cityFilterNames[index]}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'actions-filter',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cityFilterNames: [],
                cityFilter: [],
                cityActive: null,
                allActionsInit: false,
            }
        },
        methods: {
            buildFiterCity() {
                this.cityFilter = [];
                
                var data = this.actionsItemsFilter;
                var i;
                var n;
                for (i = 0; i < data.length; i++) {
                    this.cityFilter.push(data[i].action_region.slug);
                    this.cityFilterNames.push(data[i].action_region.name);
                }
                this.cityFilter = this.uniqueElementsInArray(this.cityFilter);
                this.cityFilterNames = this.uniqueElementsInArray(this.cityFilterNames);
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
            filterByCity(city) {
                this.allActionsInit = false;
                this.cityActive = city;
                var data = this.actionsItemsDefault;
                var filteredItems = data.filter(item => {
                    return item.action_region.slug == city
                })
                if (this.routerName != 'home') {
                    this.$store.commit('filterActionsItems', filteredItems);
                } else {
                    this.$store.commit('filterActionsItems', filteredItems.slice(0,2));
                }
                this.animateCards();
            },
            animateCards() {
                this.$store.commit('ActionCardAnimateSet', false);
                setTimeout(()=>{
                    this.$store.commit('ActionCardAnimateSet', true);
                },50);
            },
            allActions() {
                this.cityActive = null;
                this.allActionsInit = true;
                this.$store.commit('filterActionsItems', this.actionsItemsDefault);
                this.animateCards();
            },
            initFilterCityByPageLoad() {
                if (this.currentCity.length) {
                    this.filterByCity(this.currentCity);
                }
            }
        },
        computed: mapGetters({
            currentCity: 'loadCurrentCity',
            actionsItems: 'loadActionsItems',
            actionsItemsDefault: 'loadActionsItemsDefault',
            actionsItemsFilter: 'loadActionsItemsFilter',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            // console.info('App this router:', this.routerName);
            this.buildFiterCity();
            this.initFilterCityByPageLoad();
            this.$store.watch(
                (state) => state.actionsItemsFilter,
                (newValue) => {
                    if (newValue) {
                        this.buildFiterCity();
                        this.initFilterCityByPageLoad();
                    }
                }
            )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/actions/actions-filter.scss';
</style>